<template>
  <van-tabbar
    route
    active-color="#FF5D7D"
    inactive-color="#A7A7A7"
    placeholder
  >
    <van-tabbar-item
      v-for="item in tabBarList"
      :key="item.to"
      :to="item.to"
      :icon="item.icon"
    >{{item.name}}</van-tabbar-item>

  </van-tabbar>
</template>

<script>
export default {
  name: "TabBar",
  setup() {
    // tabbar
    const tabBarList = [
      {
        name: "首页",
        to: "/home",
        icon: "wap-home-o",
      },
      {
        name: "分类",
        to: "/category",
        icon: "apps-o",
      },
      {
        name: "我的评测",
        to: "/mine",
        icon: "user-o",
      },
    ];
    return {
      tabBarList,
    };
  },
};
</script>

